import styled from '@emotion/styled';

export const PostList = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: #fff;
	border: 1px solid ${(props) => props.theme.colors.gray100};
	border-radius: ${(props) => props.theme.effects.radiusLg};
	box-shadow: ${(props) => props.theme.effects.shadowSm};
	overflow: hidden;
	padding: 0.8rem 2.4rem;
	@media screen and (max-width: 900px) {
		padding: 0.8rem 1.6rem;
	}
`;

export const PostListItem = styled.li`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	padding: 1.6rem 0;
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
	line-height: ${(props) => props.theme.ui.lineHeight.ui};
	border-bottom: 1px solid ${(props) => props.theme.colors.gray100};
	cursor: pointer;
	transition:
		background-color ${(props) => props.theme.effects.transitionFast},
		padding-left ${(props) => props.theme.effects.transitionBase};

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		padding-left: 0.8rem;
		background-color: ${(props) => props.theme.colors.primary50};

		.title {
			color: ${(props) => props.theme.colors.primary400};
		}
	}

	.title {
		color: ${(props) => props.theme.colors.grayDarker};
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightMedium};
		transition: color ${(props) => props.theme.effects.transitionFast};
	}
	.sub_title {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.8rem;
		color: ${(props) => props.theme.colors.grayLight};
		font-size: ${(props) => props.theme.fontSize.sizeSm};
	}
`;
